import { useDeleteTextProcessor, useGetAllTextProcessors, usePatchTextProcessor } from 'api/integrationsErrors/queryHooks'
import type { TextProcessorPatternPatch } from 'api/integrationsErrors/types'
import { IntegrationError } from './IntegrationError'

export const IntegrationErrorMain = () => {
  const { data: textProcessors, isLoading } = useGetAllTextProcessors()
  const { mutate: patchTextProcessor } = usePatchTextProcessor()
  const { mutate: deleteTextProcessor } = useDeleteTextProcessor()

  const handlePatchTextProcessor = (textProcessor: TextProcessorPatternPatch) => {
    patchTextProcessor({
      id: textProcessor.id,
      pattern: textProcessor.pattern,
      matchText: textProcessor.matchText,
      isActive: textProcessor.isActive,
    })
  }

  const handleDeleteTextProcessor = (id: string) => {
    deleteTextProcessor(id)
  }

  return (
    <IntegrationError
      textProcessors={textProcessors ?? []}
      isLoading={isLoading}
      handlePatchTextProcessor={handlePatchTextProcessor}
      handleDeleteTextProcessor={handleDeleteTextProcessor}
    />
  )
}
